__webpack_require__.p = "/wp-content/themes/global-theme/static-v2/";